import { Component } from "./index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import { Emitter } from "../core"

export default class Slider {
  constructor(el) {
    this.el = el

    this.sliderInner = qs(".slider-inner", this.el)
    this.slider = qs(".slider-viewer", this.el)
    this.progressWrapper = qs(".bar", this.el)
    this.progress = qs(".progress", this.el)

    this.limitProgress = 0
    this.touching = false
    this.padding = 0
    this.scrollCurrent = 0
    this.current = 0
    this.target = 0
    this.lerp = 0.1
    this.limit = 0
    this.coef = 1.5
    this.x = {
      start: 0,
      end: 0,
    }

    this.addEvents()
  }

  addEvents = () => {
    window.addEventListener("resize", this.onResize)
    window.addEventListener("touchend", this.onTouchUp)
    window.addEventListener("mouseup", this.onTouchUp)
    this.slider.addEventListener("mousedown", this.onTouchDown)
    this.slider.addEventListener("touchstart", this.onTouchDown)
    this.slider.addEventListener("mousemove", this.onTouchMove)
    this.slider.addEventListener("touchmove", this.onTouchMove)
    this.onResize()

    Emitter.on("resize", this.onResize)

    gsap.ticker.add(this.update)
  }

  map_range = (value, low1, high1, low2, high2) => {
    return low2 + ((high2 - low2) * (value - low1)) / (high1 - low1)
  }

  onResize = () => {
    this.computeLimit()

    if (this.progress && this.progressWrapper) {
      this.computeProgress()
    }
  }

  computeLimit = () => {
    const viewZone = this.slider.getBoundingClientRect().width
    const total = this.sliderInner.getBoundingClientRect().width + this.padding

    this.limit = (total - viewZone) / this.coef

    if (Math.round(total) === Math.round(viewZone)) {
      this.slider.classList.add("slider-viewer_cursor")
    }
  }

  computeProgress = () => {
    this.limitProgress = this.progressWrapper.offsetWidth - this.progress.offsetWidth
  }

  onTouchDown = e => {
    this.touching = true

    if (e.touches && e.touches[0]) {
      this.x.start = e.touches[0].clientX
    } else {
      this.x.start = e.clientX
    }
  }

  onTouchUp = () => {
    this.x.end = this.target
    this.touching = false
  }

  onTouchMove = e => {
    if (this.touching) {
      if (e.touches && e.touches[0]) {
        this.scrollCurrent = e.touches[0].clientX
      } else {
        this.scrollCurrent = e.clientX
      }
      this.target = this.x.end + this.x.start - this.scrollCurrent
      this.target = gsap.utils.clamp(0, this.limit, this.target)
    }
  }

  update = () => {
    this.current = gsap.utils.interpolate(this.current, this.target, this.lerp)
    this.sliderInner.style.transform = `translateX(${-this.current * this.coef}px)`

    if (this.progress && this.progressWrapper) {
      const progress = this.map_range(this.current, 0, this.limit, 0, this.limitProgress)
      this.progress.style.transform = `translateX(${progress}px)`
    }
  }
}
